import React from 'react';
import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://pdfstatementconverter.net';

const COUNTRY_PATHS = {
  US: '/us',
  CA: '/ca',
  GB: '/uk',
  BR: '/br',
  AR: '/ar',
  AE: '/ae',
  ZA: '/za'
};

const HREFLANG_MAP = {
  US: 'en-us',
  CA: 'en-ca',
  GB: 'en-gb',
  BR: 'pt-br',
  AR: 'es-ar',
  AE: 'en-ae',
  ZA: 'en-za'
};

const TITLES = {
  US: 'Convert US Bank Statements to QBO, CSV, OFX - PDF Statement Converter',
  CA: 'Convert Canadian Bank Statements to QBO, CSV, OFX - PDF Statement Converter',
  GB: 'Convert UK Bank Statements to QBO, CSV, OFX - PDF Statement Converter',
  BR: 'Converter Extrato Bancário PDF para CSV, OFX, QBO - PDF Statement Converter',
  AR: 'Convertir Extractos Bancarios PDF a CSV, OFX, QBO - PDF Statement Converter',
  AE: 'Convert UAE Bank Statements to QBO, CSV, OFX - PDF Statement Converter',
  ZA: 'Convert SA Bank Statements to QBO, CSV, OFX - PDF Statement Converter'
};

const DESCRIPTIONS = {
  US: 'Convert Chase, Bank of America, Wells Fargo PDF statements to CSV, OFX, QBO. Import into QuickBooks, Xero, Sage instantly.',
  CA: 'Convert RBC, TD, Scotiabank, BMO, CIBC PDF statements to CSV, OFX, QBO. Import into QuickBooks, Xero, Sage 50 instantly.',
  GB: 'Convert Barclays, HSBC, Lloyds, NatWest PDF statements to CSV, OFX, QBO. Import into Xero, Sage, QuickBooks instantly.',
  BR: 'Converta extratos PDF do Itaú, Bradesco, Nubank, Banco do Brasil para CSV, OFX, QBO. Importe para QuickBooks, Xero, Conta Azul.',
  AR: 'Convierte extractos PDF de Galicia, Santander, BBVA, Macro a CSV, OFX, QBO. Importa a QuickBooks, Xero al instante.',
  AE: 'Convert Emirates NBD, ADCB, FAB, Mashreq PDF statements to CSV, OFX, QBO. Import into QuickBooks, Zoho Books, Tally.',
  ZA: 'Convert FNB, Standard Bank, ABSA, Nedbank, Capitec PDF statements to CSV, OFX, QBO. Import into Sage, Xero, QuickBooks.'
};

const DEFAULT_TITLE = 'PDF Statement Converter - Convert Bank Statements to CSV, OFX, QBO';
const DEFAULT_DESCRIPTION = 'Convert PDF bank statements to CSV, OFX, QBO format. Import into QuickBooks, Xero, Sage and other accounting software instantly.';

const SEOHead = ({ country }) => {
  const title = TITLES[country] || DEFAULT_TITLE;
  const description = DESCRIPTIONS[country] || DEFAULT_DESCRIPTION;
  const countryPath = COUNTRY_PATHS[country];
  const canonicalUrl = countryPath ? `${BASE_URL}${countryPath}` : `${BASE_URL}/`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* hreflang tags for all country versions */}
      {Object.entries(COUNTRY_PATHS).map(([code, path]) => (
        <link
          key={code}
          rel="alternate"
          hrefLang={HREFLANG_MAP[code]}
          href={`${BASE_URL}${path}`}
        />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${BASE_URL}/`} />
    </Helmet>
  );
};

export default SEOHead;
